import { Close } from "@carbon/icons-react";
import { SimpleTreeView } from "@mui/x-tree-view/SimpleTreeView";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import FallbackComponent from "../../../../../components/fallbackComponent/FallbackComponent";
import { InboundDeliveryItemFragment } from "../../../../../models/autogenerated-deliveryService-gql/graphql";
import { HierarchicalDeliveryItem } from "../../../../../models/hierarchicalDeliveryItem";
import "./DetailsItemsTab.scss";
import DetailsItemsTreeItem from "./detailsItemsTreeItem/DetailsItemsTreeItem";

interface DetailsItemsTabProps {
  items: InboundDeliveryItemFragment[];
}

const buildHierarchy = (items: InboundDeliveryItemFragment[]) => {
  const roots: HierarchicalDeliveryItem[] = items.map((item) => {
    return { ...item, children: [] };
  });

  const materialsToRemoveFromTopLevel: string[] = [];

  roots.forEach((item) => {
    if (materialsToRemoveFromTopLevel.includes(item.id)) return;

    if (item.__typename === "HandlingUnitItem" && item.childrenIds.length > 0) {
      item.childrenIds.map((childId) => {
        const material = roots.find((i) => i.id === childId);
        if (material) {
          item.children.push(material);
          materialsToRemoveFromTopLevel.push(childId);
        }
      });
    }
  });

  return roots.filter(
    (item) => !materialsToRemoveFromTopLevel.includes(item.id),
  );
};

const DetailsItemsTab = (props: DetailsItemsTabProps) => {
  const { t } = useTranslation();
  const { items } = props;
  const hierarchicalItems = buildHierarchy(items);

  const [expandedItems, setExpandedItems] = useState<string[]>([]);

  if (items.length === 0)
    return (
      <FallbackComponent
        middleIcon={<Close size={32} />}
        text={t("noItemsExist")}
      />
    );

  return (
    <SimpleTreeView
      onExpandedItemsChange={(event, itemIds) => setExpandedItems(itemIds)}
    >
      {hierarchicalItems.map((item, parentIndex) => (
        <DetailsItemsTreeItem
          key={parentIndex}
          item={item}
          parentIndex={parentIndex.toString()}
          expandedItems={expandedItems}
        />
      ))}
    </SimpleTreeView>
  );
};

export default DetailsItemsTab;
